module.exports = "https://website-assets.prd.scentregroup.io/checkout/_next/static/media/hero.164775c9.jpg";